module.exports = __webpack_public_path__ + "img/52.80896d4d.jpg";